import View                   from 'scripts/poppet/view';
import ForecastCollectionView from 'scripts/defa/weather/view-forecast-collection-view';
import template               from 'templates/fullForecast.jst.html';


const selectors = {
	leftPaddleButton  : '[data-click=left-paddle-clicked]',
	rightPaddleButton : '[data-click=right-paddle-clicked]',
	region            : '[data-region=weather-collection]',
};

const FullForecastView = View.extend({
	template: template,
	collection: [],
	weatherWrapperSize : 0,
	paddleMargin       : 20,
	scrollInterval     : 450,

	ui: {
		leftPaddle  : selectors.leftPaddleButton,
		rightPaddle : selectors.rightPaddleButton,
	},

	events: {
		'click @ui.leftPaddle'  : 'onClickLeftPaddle',
		'click @ui.rightPaddle' : 'onClickRightPaddle',
	},

	regions: {
		region: selectors.region
	},

	collectionEvents: {
		'sync': 'onCollectionSync',
	},
	
	templateContext: function(){
		return {
			showPaddle : this.options.paddle,
		}
	},

	onAttach: function() {
		this.weatherWrapperSize = this._getWeatherWrapperSize();
		let self = this;
		$( window ).on( 'resize', function () {
			self.weatherWrapperSize = self._getWeatherWrapperSize();
		} );
	},

	onRender: function() {
		this._showForecast();
	},
	
	onCollectionSync: function () {
		this.render();
	},

	onClickLeftPaddle: function() {
		let list = this.$el.find('.weather-list')[0];
		
		let position = list.scrollLeft;
		let scrolledPosition = position - this.scrollInterval;
		list.scroll({
		  left: scrolledPosition,
		  behavior: 'smooth'});
		this.onScroll( scrolledPosition );
	},

	onClickRightPaddle: function() {
		let list = this.$el.find('.weather-list')[0];
		let position = list.scrollLeft;
		let scrolledPosition = position + this.scrollInterval;
		list.scroll({
		  left: scrolledPosition,
		  behavior: 'smooth'});
		this.onScroll( scrolledPosition );
	},

	onScroll: function( position ) {
		let numberOfDays = $('.weather-item').length
		let weatherSize = numberOfDays *  $('.weather-item').outerWidth(true);
		let weatherInvisibleSize = weatherSize - this.weatherWrapperSize;

		// get how much have we scrolled so far
		let weatherEndOffset = weatherSize - this.scrollInterval + 1 ;

		if (position <= this.paddleMargin) {
			this.ui.leftPaddle.addClass('hidden');
			this.ui.rightPaddle.removeClass('hidden');
		} else if (position < weatherEndOffset) {
			// show both paddles in the middle
			this.ui.leftPaddle.removeClass('hidden');
			this.ui.rightPaddle.removeClass('hidden');
		} else if (position >= weatherEndOffset) {
			this.ui.leftPaddle.removeClass('hidden');
			this.ui.rightPaddle.addClass('hidden');
		}
	},

	_showForecast: function() {
		let forecast = new ForecastCollectionView({
			collection: this.collection,
		});

		this.showChildView('region', forecast);
	},

	_getWeatherWrapperSize: function() {
		return $('.weather-wrapper').outerWidth();
	},
	
});

export default FullForecastView;